<template>
  <div class="hold-transition mapa-ff-mapa-page">
    <loading v-if="cargando" />
    <div class="wrapper">
      <div class="content-wrapper">
        <section class="content-header">
          <div class="container-fluid">
            <!-- Barra Superior Compacta -->
            <div class="row justify-content-between">
              <h5 class="col-md-1">Mapa</h5>
              <ol class="col-md-3 breadcrumb">
                <li class="breadcrumb-item">
                  <router-link to="/">Home</router-link>
                </li>
                <li class="breadcrumb-item active">Hidrocarburos</li>
                <li class="breadcrumb-item active">Consultas</li>
                <li class="breadcrumb-item active">Mapas</li>
              </ol>
            </div>
          </div>
        </section>
        <section class="content">
          <div class="container-fluid">
            <!-- Contenedor del mapa -->
            <div class="row">
              <div class="col-md-12 mb-1">
                <div
                  class="map-wrapper shadow-sm rounded"
                  :class="{ fullscreen: mapFullscreen }"
                >
                  <!-- Controles estilo Google Maps (overlay) -->
                  <div class="map-overlay-ui">
                    <div class="map-overlay-top">
                      <div class="map-top-toolbar">
                        <div class="map-searchbar shadow-sm">
                          <button
                            type="button"
                            class="btn map-search-leading"
                            @click.stop="runBusquedaPlacaBarra"
                            title="Buscar placa en el mapa"
                          >
                            <i class="fas fa-search"></i>
                          </button>
                          <input
                            class="map-search-input"
                            type="text"
                            v-model.trim="mapQuickPlaca"
                            placeholder="Placa"
                            autocomplete="off"
                            spellcheck="false"
                            @keydown.enter.prevent="runBusquedaPlacaBarra"
                          />
                          <button
                            type="button"
                            class="btn map-icon-btn map-filtros-btn"
                            @click.stop="openMapaFiltrosModal"
                            title="Opciones y filtros del mapa"
                          >
                            <i class="fas fa-sliders-h"></i>
                          </button>
                          <div class="map-search-actions" @click.stop>
                            <button
                              type="button"
                              class="btn map-icon-btn"
                              @click="showCarros()"
                              title="Actualizar"
                            >
                              <i class="fas fa-sync"></i>
                            </button>
                            <button
                              type="button"
                              class="btn map-icon-btn"
                              :class="{ active: trazaViaje }"
                              @click="toggleTrazabilidad"
                              title="Trazabilidad"
                            >
                              <i class="fas fa-route"></i>
                            </button>
                          </div>
                        </div>

                        <div class="map-chips-row map-chips-row--top">
                          <button
                            type="button"
                            class="btn map-chip-nav left"
                            @click="scrollChips(-1)"
                            title="Anterior"
                            :disabled="!chipsCanScrollLeft"
                            :class="{ disabled: !chipsCanScrollLeft }"
                          >
                            <i class="fas fa-chevron-left"></i>
                          </button>

                          <div
                            class="map-chips-scroller"
                            ref="chipsScroller"
                            @scroll="updateChipsScrollButtons"
                            @wheel.prevent="onChipsWheel"
                          >
                          <!-- <label
                            class="map-chip"
                            :class="{ active: form.geocercas }"
                          >
                            <input
                              type="checkbox"
                              id="geocercas"
                              v-model="form.geocercas"
                              @change="showGeocercas()"
                              class="d-none"
                            />
                            <i class="fas fa-map-marked-alt"></i>
                            <span>Geocercas</span>
                          </label> -->

                          <!-- <label
                            class="map-chip danger"
                            :class="{ active: form.geocercasProhibidas }"
                          >
                            <input
                              type="checkbox"
                              id="geocercasProhibidas"
                              v-model="form.geocercasProhibidas"
                              @change="showGeocercasProhibidas()"
                              class="d-none"
                            />
                            <i class="fas fa-ban"></i>
                            <span>Prohibidas</span>
                          </label> -->

                          <label
                            class="map-chip success"
                            :class="{ active: form.carrosActTepViajes }"
                          >
                            <input
                              type="checkbox"
                              v-model="form.carrosActTepViajes"
                              @change="[(infoWinOpen = false), showCarros()]"
                              class="d-none"
                            />
                            <i class="fas fa-truck-moving"></i>
                            <span>Activos Tep Viajes</span>
                          </label>

                          <label
                            class="map-chip success"
                            :class="{ active: form.carrosActTepTurnos }"
                          >
                            <input
                              type="checkbox"
                              v-model="form.carrosActTepTurnos"
                              @change="[(infoWinOpen = false), showCarros()]"
                              class="d-none"
                            />
                            <i class="fas fa-truck-moving"></i>
                            <span>Activos Tep Fijos</span>
                          </label>

                          <label
                            class="map-chip success"
                            :class="{ active: form.carrosActTifTurnos }"
                          >
                            <input
                              type="checkbox"
                              v-model="form.carrosActTifTurnos"
                              @change="[(infoWinOpen = false), showCarros()]"
                              class="d-none"
                            />
                            <i class="fas fa-truck-moving"></i>
                            <span>Activos Tif Turnos</span>
                          </label>

                          <!-- <label
                            class="map-chip warning"
                            :class="{ active: form.carrosPost }"
                          >
                            <input
                              type="checkbox"
                              v-model="form.carrosPost"
                              @change="[(infoWinOpen = false), showCarros()]"
                              class="d-none"
                            />
                            <i class="fas fa-truck-moving"></i>
                            <span>Postulados</span>
                          </label> -->

                          <label
                            class="map-chip danger"
                            :class="{ active: form.carrosInact }"
                          >
                            <input
                              type="checkbox"
                              v-model="form.carrosInact"
                              @change="[(infoWinOpen = false), showCarros()]"
                              class="d-none"
                            />
                            <i class="fas fa-truck-moving"></i>
                            <span>Inactivos</span>
                          </label>

                          <label
                            class="map-chip success"
                            :class="{ active: form.rutasTep }"
                          >
                            <input
                              type="checkbox"
                              v-model="form.rutasTep"
                              @change="
                                [(infoWinOpen = false), onToggleRutasTifTep()]
                              "
                              class="d-none"
                            />
                            <i class="fas fa-route"></i>
                            <span>Rutas Tep</span>
                          </label>

                          <label
                            class="map-chip success"
                            :class="{ active: form.rutasTif }"
                          >
                            <input
                              type="checkbox"
                              v-model="form.rutasTif"
                              @change="
                                [(infoWinOpen = false), onToggleRutasTifTep()]
                              "
                              class="d-none"
                            />
                            <i class="fas fa-map-marked-alt"></i>
                            <span>Rutas Tif</span>
                          </label>

                          <label
                            class="map-chip warning"
                            :class="{ active: form.filtro_bloques_tep }"
                          >
                            <input
                              type="checkbox"
                              v-model="form.filtro_bloques_tep"
                              @change="onFiltroBloquesCapaChange"
                              class="d-none"
                            />
                            <i class="fas fa-cubes"></i>
                            <span>Bloques TEP</span>
                          </label>

                          <label
                            class="map-chip"
                            :class="{ active: form.filtro_bloques_tif }"
                          >
                            <input
                              type="checkbox"
                              v-model="form.filtro_bloques_tif"
                              @change="onFiltroBloquesCapaChange"
                              class="d-none"
                            />
                            <i class="fas fa-cubes"></i>
                            <span>Bloques TIF</span>
                          </label>
                        </div>

                        <button
                          type="button"
                          class="btn map-chip-nav right"
                          @click="scrollChips(1)"
                          title="Siguiente"
                          :disabled="!chipsCanScrollRight"
                          :class="{ disabled: !chipsCanScrollRight }"
                        >
                          <i class="fas fa-chevron-right"></i>
                        </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <button
                    type="button"
                    class="btn btn-dark btn-sm map-fullscreen-btn"
                    @click="toggleMapFullscreen"
                    :title="
                      mapFullscreen
                        ? 'Salir de pantalla completa'
                        : 'Pantalla completa'
                    "
                  >
                    <i
                      class="fas"
                      :class="mapFullscreen ? 'fa-compress' : 'fa-expand'"
                    ></i>
                  </button>
                  <gmap-map
                    :key="mapKey"
                    :center="center"
                    :zoom="zoom"
                    :map-type-id="satelite ? 'satellite' : 'roadmap'"
                    :style="{
                      width: '100%',
                      height: mapFullscreen ? '100vh' : '650px',
                    }"
                    :options="{
                      disableDefaultUI: true,
                      zoomControl: true,
                      mapTypeControl: true,
                      streetViewControl: true,
                    }"
                  >
                    <gmap-marker
                      :key="index"
                      v-for="(m, index) in markersTraza"
                      :position="m.position"
                      :icon="m.icon"
                      :animation="2"
                      @click="toggleInfoWindow(m, index, m.info)"
                    ></gmap-marker>
                    <gmap-cluster
                      :gridSize="50"
                      :zoomOnClick="true"
                      :enableRetinaIcons="true"
                      :minimumClusterSize="3"
                      :imagePath="'/img/map_cluster/m'"
                      ref="cluster"
                    >
                      <gmap-marker
                        :key="'cluster-' + m._mapIdx"
                        v-for="m in markersParaCluster"
                        :position="m.position"
                        :icon="m.icon"
                        :animation="2"
                        @click="toggleInfoWindow(m, m._mapIdx, m.info)"
                      ></gmap-marker>
                    </gmap-cluster>
                    <gmap-info-window
                      :options="infoOptions"
                      :position="infoWindowPos"
                      :opened="infoWinOpen"
                      @closeclick="infoWinOpen = false"
                    >
                      <div v-html="infoContent"></div>
                    </gmap-info-window>
                    <gmap-polygon
                      v-for="(poligono, pIdx) in poligonosTodos"
                      :options="{ fillColor: poligono.color || '#94a3b8' }"
                      :key="poligono._vueKey || 'poly-' + poligono.id + '-' + pIdx"
                      :paths="poligono.path"
                      :editable="false"
                      :draggable="false"
                      @click="
                        toggleInfoWindowPoli(
                          poligono,
                          poligono._vueKey || poligono.id,
                          poligono.info,
                        )
                      "
                    />
                    <gmap-circle
                      v-for="(circular, cIdx) in circunferenciasTodos"
                      :key="circular._vueKey || 'cir-' + cIdx"
                      :center="circular.center"
                      :radius="circular.radius"
                      :options="{
                        fillColor: circular.color || '#94a3b8',
                        fillOpacity: 0.25,
                        strokeColor: circular.color || '#64748b',
                        strokeWeight: 1,
                      }"
                      :info="circular.info"
                      @click="
                        toggleInfoWindowCir(
                          circular,
                          circular._vueKey || cIdx,
                          circular.info,
                        )
                      "
                    ></gmap-circle>
                    <gmap-polyline
                      v-for="(polyline, id) in polylinesMerged"
                      :key="id"
                      :path="polyline.path"
                      :options="polyline.options"
                      ref="polyline"
                      @click="
                        toggleInfoWindowPoli(
                          polyline,
                          id,
                          polyline.info != null ? polyline.info : '',
                        )
                      "
                    ></gmap-polyline>
                    <gmap-marker
                      v-for="(nv, nvIdx) in markersPuntosNovedad"
                      :key="'nov-traza-' + nv.id"
                      :position="nv.position"
                      :icon="nv.icon"
                      :z-index="5000"
                      @click="
                        toggleInfoWindow(nv, 500000 + nvIdx, nv.info)
                      "
                    ></gmap-marker>
                  </gmap-map>
                </div>
              </div>
              <!-- Ventana Flotante de Trazabilidad -->
              <div
                id="trazaViaje"
                class="trazabilidad-floating-window"
                :class="{ dragging: isDragging }"
                v-if="trazaViaje"
                :style="{
                  left: windowPosition.x + 'px',
                  top: windowPosition.y + 'px',
                }"
                @mousedown="startDrag"
              >
                <div class="floating-window-content">
                  <!-- Header de la Ventana Flotante -->
                  <div
                    class="floating-header card-header bg-geogo-top-left text-white pb-2"
                  >
                    <h5 class="card-title">
                      <i class="fas fa-route mr-2"></i>
                      Trazabilidad de Vehículos
                    </h5>
                    <div class="card-tools">
                      <div class="btn-group mr-2" role="group">
                        <button
                          type="button"
                          class="btn btn-primary btn-sm"
                          @click="showTraza()"
                          v-if="!$v.filter.$invalid"
                        >
                          <i class="fas fa-search"></i>
                        </button>
                        <button
                          type="button"
                          class="btn btn-outline-secondary btn-sm"
                          @click="limpiarForm()"
                        >
                          <i class="fas fa-eraser"></i>
                        </button>
                        <button
                          v-if="puntosTraza.length > 0"
                          type="button"
                          class="btn btn-success btn-sm"
                          @click="generarTrazaExcel()"
                        >
                          <i class="far fa-file-excel"></i>
                        </button>
                      </div>
                      <span
                        v-if="markersPuntosNovedad.length > 0"
                        class="badge bg-warning text-dark mr-2"
                      >
                        <i class="fas fa-exclamation-triangle mr-1"></i>
                        {{ markersPuntosNovedad.length }}
                      </span>
                      <button
                        type="button"
                        class="btn btn-outline-secondary btn-sm mr-2"
                        @click="trazabilidadCollapsed = !trazabilidadCollapsed"
                        :title="trazabilidadCollapsed ? 'Expandir' : 'Colapsar'"
                      >
                        <i
                          :class="
                            trazabilidadCollapsed
                              ? 'fas fa-chevron-down'
                              : 'fas fa-chevron-up'
                          "
                        ></i>
                      </button>
                      <button
                        type="button"
                        class="btn btn-danger btn-sm"
                        @click="toggleTrazabilidad"
                      >
                        <i class="fas fa-times"></i>
                      </button>
                    </div>
                  </div>
                  <!-- Cuerpo de la Ventana Flotante -->
                  <div
                    class="floating-body p-3 bg-light card-body"
                    v-show="!trazabilidadCollapsed"
                  >
                    <!-- Fila principal: Buscar por + Campo de búsqueda -->
                    <div class="row align-items-start">
                      <!-- Select Buscar por -->
                      <div class="form-group col-md-6">
                        <label class="form-label mb-1 small">
                          Buscar por:
                        </label>
                        <div class="input-group input-group-sm">
                          <div class="input-group-prepend">
                            <span class="input-group-text bg-light"
                              ><i class="fas fa-search text-muted"></i
                            ></span>
                          </div>
                          <v-select
                            class="form-control form-control-xs p-0 w-90"
                            :class="
                              $store.getters.getDarkMode ? 'dark-vselect' : ''
                            "
                            v-model="filter.buscar_por"
                            label="buscar_por"
                            :options="listasForms.buscar_por"
                            :reduce="(o) => o.buscar_por"
                            @input="limpiarForm()"
                          ></v-select>
                        </div>
                        <!-- Mensajes informativos -->
                        <div class="row mb-3">
                          <div v-if="filter.placa" class="col-12">
                            <small
                              v-if="
                                filter.placa &&
                                  filter.periodo &&
                                  filter.periodo !== 'personalizado'
                              "
                              class="text-success"
                            >
                              <i class="fas fa-check-circle mr-1"></i> Búsqueda
                              automática activada
                            </small>
                            <small
                              v-if="filter.mensaje_tiempo"
                              class="text-info d-block"
                            >
                              <i class="fas fa-clock mr-1"></i>
                              {{ filter.mensaje_tiempo }}
                            </small>
                          </div>
                        </div>
                      </div>

                      <!-- Campo de búsqueda dinámico -->
                      <div class="form-group col-md-6" v-if="filter.buscar_por">
                        <!-- Campo Placa -->
                        <div v-if="filter.buscar_por === 'Placa'">
                          <label class="form-label mb-1 small">
                            <i class="fas fa-truck text-primary mr-1"></i>
                            Vehículo
                          </label>
                          <div class="input-group input-group-sm">
                            <div class="input-group-prepend">
                              <span class="input-group-text bg-light">
                                <i class="fas fa-truck text-muted"></i>
                              </span>
                            </div>
                            <input
                              type="text"
                              class="form-control"
                              :class="{
                                'border-primary':
                                  filter.placa &&
                                  filter.periodo &&
                                  filter.periodo !== 'personalizado',
                              }"
                              placeholder="Ingrese la placa del vehículo"
                              v-model="filter.placa"
                              @keypress.enter="onPlacaChange"
                            />
                          </div>
                        </div>

                        <!-- Campo Viaje -->
                        <div v-if="filter.buscar_por != 'Placa'">
                          <label class="form-label mb-1 small">
                            <i
                              class="fas fa-map-marked-alt text-primary mr-1"
                            ></i>
                            Viaje
                          </label>
                          <div class="input-group input-group-sm">
                            <div class="input-group-prepend">
                              <span class="input-group-text bg-light">
                                <i class="fas fa-map-marked-alt text-muted"></i>
                              </span>
                            </div>
                            <input
                              type="number"
                              class="form-control form-control-sm"
                              placeholder="Viaje"
                              v-model="filter.viaje_id"
                              @keypress.enter="showTraza()"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-if="!filter.buscar_por" class="row">
                      <div class="col-12">
                        <div class="alert alert-info border-0 py-2 mb-3">
                          <i class="fas fa-info-circle mr-2"></i>
                          <strong>Seleccione un método de búsqueda</strong> para
                          realizar la trazabilidad de un vehículo o un viaje.
                        </div>
                      </div>
                    </div>
                    <!-- Sección de fechas para Placa -->
                    <template v-if="filter.buscar_por === 'Placa'">
                      <!-- Períodos Rápidos -->
                      <div class="row mb-3">
                        <div class="col-12">
                          <label class="form-label text-dark mb-2 small">
                            <i
                              class="fas fa-calendar-alt text-primary mr-1"
                            ></i>
                            Período
                          </label>
                          <div class="row">
                            <div class="col-md-6 mb-2">
                              <div class="btn-group w-100" role="group">
                                <button
                                  type="button"
                                  class="btn btn-outline-primary btn-sm"
                                  :class="{ active: filter.periodo === 'hoy' }"
                                  @click="setPeriodo('hoy')"
                                >
                                  <i class="fas fa-calendar-day mr-1"></i> Hoy
                                </button>
                                <button
                                  type="button"
                                  class="btn btn-outline-primary btn-sm"
                                  :class="{ active: filter.periodo === 'ayer' }"
                                  @click="setPeriodo('ayer')"
                                >
                                  <i class="fas fa-calendar-minus mr-1"></i>
                                  Ayer
                                </button>
                              </div>
                            </div>
                            <div class="col-md-6 mb-2">
                              <div class="btn-group w-100" role="group">
                                <button
                                  type="button"
                                  class="btn btn-outline-primary btn-sm"
                                  :class="{
                                    active: filter.periodo === 'semana',
                                  }"
                                  @click="setPeriodo('semana')"
                                >
                                  <i class="fas fa-calendar-week mr-1"></i>
                                  Semana
                                </button>
                                <button
                                  type="button"
                                  class="btn btn-outline-primary btn-sm"
                                  :class="{ active: filter.periodo === 'mes' }"
                                  @click="setPeriodo('mes')"
                                >
                                  <i class="fas fa-calendar mr-1"></i> Mes
                                </button>
                              </div>
                            </div>
                          </div>

                          <!-- Botón para fecha personalizada -->
                          <div
                            class="text-center"
                            v-if="filter.periodo !== 'personalizado'"
                          >
                            <button
                              type="button"
                              class="btn btn-link btn-sm text-muted p-0"
                              @click="setPeriodo('personalizado')"
                            >
                              <i class="fas fa-cog mr-1"></i> Fecha
                              personalizada
                            </button>
                          </div>
                        </div>
                      </div>
                      <!-- Campos de Fecha Manual (Colapsable) -->
                      <div
                        class="row mt-3"
                        v-if="filter.periodo === 'personalizado'"
                      >
                        <!-- Controles para desplazar rango -->
                        <div class="col-12 mb-2">
                          <div class="d-flex justify-content-center gap-2">
                            <button
                              type="button"
                              class="btn btn-outline-primary btn-sm"
                              @click="shiftRangoFechas(-1)"
                              title="Día anterior"
                            >
                              <i class="fas fa-chevron-left mr-1"></i>
                              Día
                            </button>
                            <button
                              type="button"
                              class="btn btn-outline-primary btn-sm"
                              @click="shiftRangoFechas(1)"
                              title="Día siguiente"
                            >
                              Día
                              <i class="fas fa-chevron-right ml-1"></i>
                            </button>
                          </div>
                        </div>
                        <!-- Fecha y Hora Inicio -->
                        <div class="col-md-6 mb-3">
                          <label class="form-label fw-bold text-dark mb-2">
                            <i class="fas fa-play-circle text-success mr-1"></i>
                            Inicio
                          </label>
                          <div class="row">
                            <div class="col-7">
                              <input
                                type="date"
                                v-model="filter.fecha_inicio"
                                @change="validaFechas"
                                class="form-control form-control-sm"
                                :max="new Date().toISOString().split('T')[0]"
                                placeholder="Fecha"
                              />
                            </div>
                            <div class="col-5">
                              <input
                                type="time"
                                v-model="filter.hora_inicio"
                                @change="validaFechas"
                                class="form-control form-control-sm"
                                placeholder="Hora"
                              />
                            </div>
                          </div>
                        </div>
                        <!-- Fecha y Hora Fin -->
                        <div class="col-md-6 mb-3">
                          <label class="form-label fw-bold text-dark mb-2">
                            <i class="fas fa-stop-circle text-danger mr-1"></i>
                            Fin
                          </label>
                          <div class="row">
                            <div class="col-7">
                              <input
                                type="date"
                                v-model="filter.fecha_fin"
                                @change="validaFechas"
                                class="form-control form-control-sm"
                                :max="new Date().toISOString().split('T')[0]"
                                placeholder="Fecha"
                              />
                            </div>
                            <div class="col-5">
                              <input
                                type="time"
                                v-model="filter.hora_fin"
                                @change="validaFechas"
                                class="form-control form-control-sm"
                                placeholder="Hora"
                              />
                            </div>
                          </div>
                        </div>
                        <!-- Botón para volver a fechas rápidas -->
                        <div class="col-12 text-center">
                          <button
                            type="button"
                            class="btn btn-outline-secondary btn-sm"
                            @click="setPeriodo('hoy')"
                          >
                            <i class="fas fa-arrow-left mr-1"></i> Volver a
                            fechas rápidas
                          </button>
                        </div>
                      </div>
                    </template>

                    <!-- Información del Vehículo Compacta -->
                    <div v-if="vehiculoTraza" class="card">
                      <div class="card-header bg-lightblue border-0 py-2 m-0">
                        <div class="row align-items-center">
                          <div class="col-md-8">
                            <h6 class="mb-0">
                              <i class="fas fa-info-circle mr-2"></i>
                              Información del Vehículo
                            </h6>
                          </div>
                          <div class="col-md-4 text-right">
                            <span
                              v-if="vehiculoTraza.empresa"
                              class="badge bg-geogo text-white"
                            >
                              {{ vehiculoTraza.empresa.razon_social }}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div class="card-body py-3">
                        <div class="row align-items-center">
                          <!-- Información Principal Compacta -->
                          <div class="col-lg-6 mb-2">
                            <div class="d-flex align-items-center mb-2">
                              <div
                                class="bg-primary text-white rounded-circle p-2 mr-3"
                              >
                                <i class="fas fa-truck"></i>
                              </div>
                              <div>
                                <h5 class="mb-0 text-dark">
                                  {{ vehiculoTraza.placa }}
                                </h5>
                                <small
                                  v-if="vehiculoTraza.tipo_vehiculo"
                                  class="text-muted"
                                >
                                  {{ vehiculoTraza.tipo_vehiculo.nombre }}
                                </small>
                              </div>
                            </div>

                            <!-- Detalles del Vehículo Compactos -->
                            <div class="row">
                              <div
                                class="col-4 mb-1"
                                v-if="vehiculoTraza.nMarca"
                              >
                                <div class="d-flex align-items-center">
                                  <i
                                    class="fas fa-trademark text-primary me-1"
                                  ></i>
                                  <div>
                                    <small class="text-muted d-block"
                                      >Marca</small
                                    >
                                    <strong class="text-dark small">{{
                                      vehiculoTraza.nMarca
                                    }}</strong>
                                  </div>
                                </div>
                              </div>
                              <div
                                class="col-4 mb-1"
                                v-if="vehiculoTraza.nCombustible"
                              >
                                <div class="d-flex align-items-center">
                                  <i
                                    class="fas fa-gas-pump text-success me-1"
                                  ></i>
                                  <div>
                                    <small class="text-muted d-block"
                                      >Combustible</small
                                    >
                                    <strong class="text-dark small">{{
                                      vehiculoTraza.nCombustible
                                    }}</strong>
                                  </div>
                                </div>
                              </div>
                              <div
                                class="col-4 mb-1"
                                v-if="vehiculoTraza.nTipoCarroceria"
                              >
                                <div class="d-flex align-items-center">
                                  <i class="fas fa-truck text-info me-1"></i>
                                  <div>
                                    <small class="text-muted d-block"
                                      >Carrocería</small
                                    >
                                    <strong class="text-dark small">{{
                                      vehiculoTraza.nTipoCarroceria
                                    }}</strong>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <!-- Estadísticas Compactas -->
                          <div class="col-lg-6 mb-2">
                            <div class="row">
                              <div class="col-6 mb-2">
                                <div class="text-center p-2 bg-light rounded">
                                  <i
                                    class="fas fa-map-marker-alt text-primary fa-lg mb-1"
                                  ></i>
                                  <h6 class="mb-0 text-dark">
                                    {{ puntosTraza.length }}
                                  </h6>
                                  <small class="text-muted">Puntos</small>
                                </div>
                              </div>
                              <div class="col-6 mb-2">
                                <div class="text-center p-2 bg-light rounded">
                                  <i
                                    class="fas fa-exclamation-triangle fa-lg mb-1"
                                    :class="
                                      markersPuntosNovedad.length > 0
                                        ? 'text-warning'
                                        : 'text-success'
                                    "
                                  ></i>
                                  <h6
                                    class="mb-0"
                                    :class="
                                      markersPuntosNovedad.length > 0
                                        ? 'text-warning'
                                        : 'text-success'
                                    "
                                  >
                                    {{ markersPuntosNovedad.length }}
                                  </h6>
                                  <small class="text-muted">Novedades</small>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <!-- Estado de la Trazabilidad Compacto -->
                        <div class="row mt-2">
                          <div class="col-12">
                            <div
                              v-if="puntosTraza.length > 0"
                              class="alert alert-default-success border-0 py-2"
                            >
                              <div class="row align-items-center">
                                <div class="col-md-8">
                                  <i class="fas fa-check-circle mr-2"></i>
                                  <strong>Trazabilidad completa:</strong>
                                  {{ puntosTraza.length }} puntos
                                  automáticamente.
                                </div>
                                <div class="col-md-4 text-right">
                                  <small class="text-muted">
                                    <i
                                      class="fas fa-map-marker-alt text-success mr-1"
                                    ></i>
                                    Inicio:
                                    {{
                                      puntosTraza[0]?.dteFechaReporte || "N/A"
                                    }}
                                    <br />
                                    <i
                                      class="fas fa-flag-checkered text-danger mr-1"
                                    ></i>
                                    Fin:
                                    {{
                                      puntosTraza[puntosTraza.length - 1]
                                        ?.dteFechaReporte || "N/A"
                                    }}
                                  </small>
                                </div>
                              </div>
                            </div>
                            <div
                              v-else
                              class="alert alert-warning border-0 py-2 m-0"
                            >
                              <i class="fas fa-exclamation-triangle mr-2"></i>
                              No se encontró trazabilidad para el vehículo
                              dentro de los parámetros seleccionados.
                            </div>
                          </div>
                        </div>

                        <!-- Formulario de vista de puntos de GPS en el mapa -->
                        <div
                          v-if="puntosTraza.length > 0"
                          class="form-group custom-control custom-switch"
                        >
                          <input
                            type="checkbox"
                            class="custom-control-input"
                            id="switchTraza"
                            v-model="trazaSegmentada"
                            @change="getTrazaSegmentada()"
                          />
                          <label class="custom-control-label" for="switchTraza"
                            >Ver trazabilidad
                            {{
                              trazaSegmentada ? "segmentada" : "completa"
                            }}</label
                          >
                        </div>
                        <div
                          v-if="puntosTraza.length > 0 && !trazaSegmentada"
                          class="row"
                        >
                          <div class="form-group col-md-6">
                            <label class="form-label mb-1 small"
                              >Cantidad de puntos a mostrar</label
                            >
                            <input
                              type="number"
                              min="1"
                              class="form-control form-control-sm"
                              placeholder="Cantidad Puntos"
                              v-model="filter.cantidad"
                            />
                          </div>
                          <div class="form-group col-md-6">
                            <br />
                            <div
                              class="btn-group float-right pt-1"
                              role="group"
                              v-if="puntosTraza[0] && filter.cantidad"
                            >
                              <button
                                type="button"
                                class="btn bg-info border-light"
                                id="atras"
                                :disabled="!markersTraza[1] || !filter.cantidad"
                                @click="backPoint()"
                              >
                                <i class="fas fa-angle-double-left"></i>
                              </button>
                              <button
                                type="button"
                                class="btn bg-info border-light"
                                id="adelante"
                                :disabled="
                                  markersTraza.length >= puntosTraza.length ||
                                    !filter.cantidad
                                "
                                @click="nextPoint()"
                              >
                                <i class="fas fa-angle-double-right"></i>
                              </button>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-12" v-if="puntosTraza.length > 0">
                            <div class="progress progress-sm">
                              <div
                                class="progress-bar bg-success"
                                role="progressbar"
                                :style="{ width: progresoTraza + '%' }"
                                :aria-valuenow="progresoTraza"
                                aria-valuemin="0"
                                aria-valuemax="100"
                              ></div>
                            </div>
                            <div
                              class="d-flex justify-content-between align-items-center"
                            >
                              <small class="text-muted"
                                >Progreso trazabilidad</small
                              >
                              <small class="text-muted">
                                {{ markersTraza.length }} /
                                {{ puntosTraza.length }} ({{ progresoTraza }}%)
                              </small>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- fin Información del Vehículo Compacta -->
                  </div>
                </div>
              </div>
            </div>
            <!-- Complemento del mapa e informacion de vehiculos -->
            <div class="row form-group justify-content-center text-lg">
              <div class="badge bg-white shadow-sm m-1 p-0">
                <div class="row justify-content-between pl-2 pr-2">
                  <div class="badge bg-dark m-1">
                    <i class="fas fa-truck-moving p-1 text-success"></i>
                    <strong
                      >Tep Viajes Activos - {{ conteoGeneral?.tep_viajes || 0 }}
                    </strong>
                  </div>
                  <div class="badge bg-dark m-1">
                    <i class="fas fa-truck-moving p-1 text-white"></i>
                    <strong
                      >Tep Fijos Activos - {{ conteoGeneral?.tep_turnos || 0 }}
                    </strong>
                  </div>
                  <div class="badge bg-dark m-1">
                    <i class="fas fa-truck-moving p-1 text-info"></i>
                    <strong
                      >Tif Turnos Activos - {{ conteoGeneral?.tif_turnos || 0 }}
                    </strong>
                  </div>
                  <div class="badge bg-dark m-1">
                    <i class="fas fa-truck-moving p-1 text-danger"></i>
                    <strong
                      >Inactivos - {{ conteoGeneral?.inactivos || 0 }}</strong
                    >
                  </div>
                  <!-- <div class="badge bg-dark m-1">
                    <i class="fas fa-truck-moving p-1 text-primary"></i>
                    <strong>Postulados - </strong>
                  </div> -->
                </div>
              </div>
            </div>
            <template v-if="mostrarTablaVehiculos">
              <MapasListVehiculos ref="MapasListVehiculos" />
            </template>
          </div>
        </section>
        <MapasOptions
          ref="MapasOptions"
          @update-rutas-polylines="onUpdateRutasPolylines"
        />
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import vSelect from "vue-select";
import MapasOptions from "./MapasOptions";
import MapasListVehiculos from "./MapasListVehiculos";
import GmapCluster from "vue2-google-maps/dist/components/cluster";
import Loading from "../../../../components/Loading";
import $ from "jquery";
import "jquery-ui-dist/jquery-ui";
import { required } from "vuelidate/lib/validators";
// import RutaPolilineasVue from "../../../admin/basico/rutas/RutaPolilineas.vue";

export default {
  name: "Mapas",

  components: {
    Loading,
    MapasOptions,
    MapasListVehiculos,
    GmapCluster,
    vSelect,
  },

  data() {
    return {
      cargando: false,
      satelite: false,
      isDragging: false,
      windowPosition: { x: 20, y: 20 },
      markersPuntosNovedad: [],
      dragOffset: { x: 0, y: 0 },
      trazabilidadCollapsed: false,
      vehiculoTraza: null,
      searchTimeout: null,
      infoContent: "",
      infoWindowPos: {
        lat: 0,
        lng: 0,
      },
      infoWinOpen: false,
      currentMidx: null,
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35,
        },
      },
      form: {
        geocercas: false,
        geocercasProhibidas: false,
        carrosActTepViajes: false,
        carrosActTepTurnos: false,
        carrosActTifTurnos: false,
        carrosInact: false,
        carrosPost: false,
        rutasTep: false,
        rutasTif: false,
        filtro_bloques_tep: false,
        filtro_bloques_tif: false,
        type_bloque: null,
        bloque_id: null,
      },
      filter: {
        buscar_por: "Placa",
        placa: null,
        fecha_inicio: null,
        fecha_fin: null,
        hora_inicio: null,
        hora_fin: null,
        viaje_id: null,
        mensaje_tiempo: null,
        limite_registros: null,
        periodo: null,
        cantidad: null,
      },
      trazaSegmentada: true,
      listasForms: {
        empresas: [],
        rutas: [],
        buscar_por: [
          { buscar_por: "Placa" },
          { buscar_por: "TepTurno" },
          { buscar_por: "TifTurno" },
          { buscar_por: "TepViaje" },
        ],
      },
      colorsArray: [
        "#FF0000",
        "#00FF00",
        "#0000FF",
        "#FFFF00",
        "#16DEC3",
        "#5B0823",
      ],
      mapKey: 0,
      center: { lat: 4.651371, lng: -74.071509 },
      zoom: 6,
      markers: [],
      markersTraza: [],
      locations: {},
      mapFullscreen: false,
      chipsCanScrollLeft: false,
      chipsCanScrollRight: false,
      chipsResizeObserver: null,
      /** Placa escrita en la barra superior (sin abrir modal). */
      mapQuickPlaca: "",
      poligonos: [],
      circunferencias: [],
      /** Geocercas de bloques TEP/TIF (capa aparte de hidrocarburos). */
      poligonosBloquesCapa: [],
      circunferenciasBloquesCapa: [],
      puntosTraza: [],
      trazaViaje: false,
      det_ruta: [],
      polylines: {},
      polylinesRutasTramos: {},
      pathPoli: [],
      conteoGeneral: {},
      dataPaginaActivos: {},
      dataPaginaInactivos: {},
    };
  },

  computed: {
    polylinesMerged() {
      return { ...this.polylines, ...this.polylinesRutasTramos };
    },
    poligonosTodos() {
      return [...this.poligonos, ...this.poligonosBloquesCapa];
    },
    circunferenciasTodos() {
      return [...this.circunferencias, ...this.circunferenciasBloquesCapa];
    },
    progresoTraza() {
      const total = this.puntosTraza.length || 0;
      if (!total) return 0;
      const avance = this.markersTraza.length || 0;
      const pct = Math.floor((avance / total) * 100);
      return Math.max(0, Math.min(100, pct));
    },
    /** Solo marcadores con LatLng numérico válido (evita errores en GmapCluster). */
    markersParaCluster() {
      const result = [];
      this.markers.forEach((m, origIndex) => {
        const p = m && m.position;
        if (!p) return;
        const lat = Number(p.lat);
        const lng = Number(p.lng);
        if (!Number.isFinite(lat) || !Number.isFinite(lng)) return;
        if (lat < -90 || lat > 90 || lng < -180 || lng > 180) return;
        result.push({
          ...m,
          position: { lat, lng },
          _mapIdx: origIndex,
        });
      });
      return result;
    },
    /** Incluye conteo del mapa: si hay inactivos en badges pero `dataPagina*` aún vacío, sigue mostrando la tabla. */
    mostrarTablaVehiculos() {
      const dA = this.dataPaginaActivos?.data;
      const dI = this.dataPaginaInactivos?.data;
      if (Array.isArray(dA) && dA.length) return true;
      if (Array.isArray(dI) && dI.length) return true;
      const c = this.conteoGeneral || {};
      const sumaActivos =
        (Number(c.tep_viajes) || 0) +
        (Number(c.tif_turnos) || 0) +
        (Number(c.tep_turnos) || 0);
      const inact = Number(c.inactivos) || 0;
      return sumaActivos > 0 || inact > 0;
    },
  },

  validations() {
    let filter = [];
    switch (this.filter.buscar_por) {
      case "Placa":
        filter = {
          placa: {
            required,
          },
          fecha_inicio: {
            required,
          },
          fecha_fin: {
            required,
          },
          hora_inicio: {
            required,
          },
          hora_fin: {
            required,
          },
        };
        break;
      case "Viaje":
        filter = {
          viaje_id: {
            required,
          },
        };
        break;
      default:
        filter = {
          buscar_por: {
            required,
          },
        };
        break;
    }
    return { filter };
  },

  methods: {
    // ==================== UI OVERLAY (chips scroller) ====================
    initChipsScroller() {
      this.$nextTick(() => {
        const el = this.$refs.chipsScroller;
        if (!el) return;

        this.updateChipsScrollButtons();

        if (window.ResizeObserver) {
          this.chipsResizeObserver = new ResizeObserver(() => {
            this.updateChipsScrollButtons();
          });
          this.chipsResizeObserver.observe(el);
        }
      });
    },

    updateChipsScrollButtons() {
      const el = this.$refs.chipsScroller;
      if (!el) return;

      const maxScrollLeft = el.scrollWidth - el.clientWidth;
      const left = el.scrollLeft;

      // margen de 2px para evitar flicker
      this.chipsCanScrollLeft = left > 2;
      this.chipsCanScrollRight = maxScrollLeft - left > 2;
    },

    scrollChips(dir) {
      const el = this.$refs.chipsScroller;
      if (!el) return;

      const amount = Math.max(180, Math.floor(el.clientWidth * 0.6));
      el.scrollBy({ left: dir * amount, behavior: "smooth" });
    },

    onChipsWheel(e) {
      const el = this.$refs.chipsScroller;
      if (!el) return;
      const delta = e.deltaY || e.deltaX || 0;
      el.scrollLeft += delta;
      this.updateChipsScrollButtons();
    },

    // ==================== MÉTODOS QUE CARGAN LISTAS ====================
    getRutas() {
      axios.get("/api/admin/rutas/lista").then((response) => {
        this.listasForms.rutas = response.data;
      });
    },

    // ==================== MÉTODOS QUE AFECTAN EL MAPA ====================
    async showDraggable() {
      this.$nextTick(() => {
        const el = document.getElementById("trazaViaje");
        if (!el || !window.$) {
          return;
        }
        if (this.trazaViaje) {
          $(el).css("display", "block");
          try {
            if ($(el).data("ui-draggable")) {
              $(el).draggable("destroy");
            }
          } catch (e) {
            /* ignore */
          }
          $(el).draggable({ handle: ".floating-header" });
        } else {
          try {
            if ($(el).data("ui-draggable")) {
              $(el).draggable("destroy");
            }
          } catch (e) {
            /* ignore */
          }
          $(el).css("display", "none");
        }
      });
    },

    toggleTrazabilidad() {
      this.trazaViaje = !this.trazaViaje;
      this.showDraggable();
    },

    openMapaFiltrosModal() {
      this.infoWinOpen = false;
      const mo = this.$refs.MapasOptions;
      if (mo && mo.filter) {
        const placas = this.placasDesdeFiltroModalVehiculo(mo.filter.vehiculo);
        if (placas.length === 1) {
          this.mapQuickPlaca = placas[0];
        }
      }
      this.$nextTick(() => {
        if (window.$ && typeof window.$("#modal_aside_mapa").modal === "function") {
          window.$("#modal_aside_mapa").modal("show");
        }
      });
    },

    /**
     * Aplica la placa de la barra superior al filtro del modal y refresca marcadores.
     */
    runBusquedaPlacaBarra() {
      const p = (this.mapQuickPlaca || "").trim().toUpperCase();
      const mo = this.$refs.MapasOptions;
      if (mo && mo.filter) {
        if (p) {
          this.$set(mo.filter, "vehiculo", [p]);
        } else {
          this.$set(mo.filter, "vehiculo", []);
        }
      }
      this.infoWinOpen = false;
      this.showCarros();
    },

    generarTrazaExcel() {
      this.cargando = true;
      axios({
        method: "POST",
        url: "/api/hidrocarburos/mapas/exportTraza",
        data: { filtros: this.filter },
      })
        .then((response) => {
          let data = response.data;
          if (data.msj) {
            this.$swal({
              icon: "error",
              title: data.msj,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
            this.cargando = false;
          } else {
            this.cargando = false;
            location.href = data.url;
          }
        })
        .catch((e) => {
          this.$swal({
            icon: "error",
            title: "Ocurrió un error: " + e,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
          this.cargando = false;
        });
    },

    pintarPolylineTraza() {
      const path = [];
      for (let i = 0; i < this.puntosTraza.length; i++) {
        const lat = parseFloat(this.puntosTraza[i].latitud);
        const lng = parseFloat(this.puntosTraza[i].longitud);
        if (!isNaN(lat) && !isNaN(lng)) {
          path.push({ lat: lat, lng: lng });
        }
      }
      if (path.length > 1) {
        this.$set(this.polylines, "trazaVehiculo", {
          path: path,
          options: {
            strokeColor: "#1976d2",
            strokeWeight: 4,
            strokeOpacity: 0.85,
            geodesic: true,
          },
          info: "",
        });
        this.center = path[path.length - 1];
        this.zoom = 12;
      } else if (this.polylines.trazaVehiculo) {
        this.$delete(this.polylines, "trazaVehiculo");
      }
    },

    getTrazaSegmentada() {
      this.pintarPolylineTraza();
      this.markersTraza = [];
      if (!this.puntosTraza.length) {
        return;
      }
      const me = this;
      const indices = [];
      if (this.trazaSegmentada) {
        const maxMarkers = 200;
        const total = this.puntosTraza.length;
        if (total <= maxMarkers) {
          for (let i = 0; i < total; i++) {
            indices.push(i);
          }
        } else {
          const step = (total - 1) / (maxMarkers - 1);
          for (let i = 0; i < maxMarkers; i++) {
            indices.push(Math.round(i * step));
          }
        }
      } else {
        indices.push(0);
        this.filter.cantidad = null;
      }

      const chunkSize = 40;
      let pos = 0;
      const gen = (this._trazaPaintGen = (this._trazaPaintGen || 0) + 1);
      const pintarChunk = function () {
        if (gen !== me._trazaPaintGen) {
          return;
        }
        const end = Math.min(pos + chunkSize, indices.length);
        for (; pos < end; pos++) {
          const i = indices[pos];
          const marker = {
            lat: parseFloat(me.puntosTraza[i].latitud),
            lng: parseFloat(me.puntosTraza[i].longitud),
          };
          me.markersTraza.push({
            id: me.puntosTraza[i].id,
            position: marker,
            info: me.puntosTraza[i].ventana,
            icon: me.getSvgIconViaje(i),
          });
        }
        if (pos < indices.length) {
          if (window.requestAnimationFrame) {
            window.requestAnimationFrame(pintarChunk);
          } else {
            setTimeout(pintarChunk, 0);
          }
        }
      };
      pintarChunk();
    },

    aplicarNovedadesATraza(lista) {
      if (!Array.isArray(lista) || lista.length === 0) {
        this.markersPuntosNovedad = [];
        return;
      }
      const google = window.google;
      this.markersPuntosNovedad = lista.map((n) => {
        const lat = parseFloat(n.latitud);
        const lng = parseFloat(n.longitud);
        return {
          id: n.id,
          position: { lat, lng },
          icon: this.iconoNovedadTrazaRuta(n.relevancia, google),
          info: n.ventana || "",
        };
      });
    },

    iconoNovedadTrazaRuta(relevancia, google) {
      const iconColors = {
        1: "#ffc107",
        2: "#dc3545",
        3: "#17a2b8",
      };
      const color = iconColors[relevancia] || "#6c757d";
      if (!google || !google.maps) {
        return { url: "" };
      }
      return {
        path:
          "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z",
        fillColor: color,
        fillOpacity: 1,
        strokeColor: "#ffffff",
        strokeWeight: 2,
        scale: 1.6,
        anchor: new google.maps.Point(12, 24),
      };
    },

    nextPoint() {
      let dist =
        parseInt(this.markersTraza.length - 1) + parseInt(this.filter.cantidad);
      for (let i = this.markersTraza.length - 1; i < dist; i++) {
        if (this.markersTraza.length < this.puntosTraza.length) {
          const marker = {
            lat: parseFloat(this.puntosTraza[i].latitud),
            lng: parseFloat(this.puntosTraza[i].longitud),
          };
          this.markersTraza.push({
            id: this.puntosTraza[i].id,
            position: marker,
            info: this.puntosTraza[i].ventana,
            icon: this.getSvgIconViaje(i),
          });
          this.center = marker;
          this.zoom = 13;
        } else {
          const marker = {
            lat: parseFloat(this.puntosTraza[i].latitud),
            lng: parseFloat(this.puntosTraza[i].longitud),
          };
          this.markersTraza.push({
            id: this.puntosTraza[i].id,
            position: marker,
            info: this.puntosTraza[i].ventana,
            icon: this.getSvgIconViaje(i),
          });
          this.$swal({
            title: "Fin del recorrido!",
            text: "No se encontraron más tramas para este viaje",
            icon: "info",
          });

          break;
        }
      }
    },

    backPoint() {
      let dist =
        parseInt(this.markersTraza.length - 1) - parseInt(this.filter.cantidad);
      for (let i = this.markersTraza.length - 1; i > dist; i--) {
        this.markersTraza.splice(i, 1);
      }
      this.center = {
        lat: parseFloat(
          this.markersTraza[this.markersTraza.length - 1].position.lat,
        ),
        lng: parseFloat(
          this.markersTraza[this.markersTraza.length - 1].position.lng,
        ),
      };
    },

    // Función para calcular la dirección entre dos puntos usando coordenadas
    getDireccion(index) {
      const puntoActual = this.puntosTraza[index];
      const puntoSiguiente = this.puntosTraza[index + 1];

      // Si no hay punto siguiente, buscar hacia atrás
      if (!puntoSiguiente) {
        const puntoAnterior = this.puntosTraza[index - 1];
        if (!puntoAnterior) return 0; // Sin dirección

        // Calcular dirección desde el punto anterior al actual
        return this.calcularDireccion(
          parseFloat(puntoAnterior.latitud),
          parseFloat(puntoAnterior.longitud),
          parseFloat(puntoActual.latitud),
          parseFloat(puntoActual.longitud),
        );
      }
      // Calcular dirección desde el punto actual al siguiente
      return this.calcularDireccion(
        parseFloat(puntoActual.latitud),
        parseFloat(puntoActual.longitud),
        parseFloat(puntoSiguiente.latitud),
        parseFloat(puntoSiguiente.longitud),
      );
    },

    // Función para calcular el bearing (dirección) entre dos coordenadas
    calcularDireccion(lat1, lon1, lat2, lon2) {
      // Convertir grados a radianes
      const lat1Rad = (lat1 * Math.PI) / 180;
      const lat2Rad = (lat2 * Math.PI) / 180;
      const deltaLonRad = ((lon2 - lon1) * Math.PI) / 180;

      // Calcular el bearing usando la fórmula de Haversine
      const y = Math.sin(deltaLonRad) * Math.cos(lat2Rad);
      const x =
        Math.cos(lat1Rad) * Math.sin(lat2Rad) -
        Math.sin(lat1Rad) * Math.cos(lat2Rad) * Math.cos(deltaLonRad);

      // Calcular el ángulo en radianes
      let bearingRad = Math.atan2(y, x);

      // Convertir a grados y normalizar a 0-360
      let bearingDeg = (bearingRad * 180) / Math.PI;
      bearingDeg = (bearingDeg + 360) % 360;

      return Math.round(bearingDeg);
    },

    getSvgIconViaje(index) {
      const google = window.google;
      const puntoTraza = this.puntosTraza[index];
      const esPrimerPunto = index === 0;
      const esUltimoPunto = index === this.puntosTraza.length - 1;
      const velocidad = parseFloat(puntoTraza.velocidad || 0);

      let svgPath = "";

      // SVG de Inicio de Ruta (primer punto) - bandera verde, más destacada que el resto
      if (esPrimerPunto) {
        svgPath = `
          <svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56">
            <circle cx="28" cy="28" r="27" fill="#fff" stroke="#28a745" stroke-width="3"/>
            <line x1="28" y1="44" x2="28" y2="12" stroke="#5a6268" stroke-width="2.5" stroke-linecap="round"/>
            <path d="M 28 12 L 28 28 L 46 20 Z" fill="#28a745" stroke="#1e7e34" stroke-width="1.5"/>
            <circle cx="28" cy="44" r="3" fill="#28a745"/>
          </svg>
        `;
      }
      // SVG de Final de Ruta (último punto) - bandera roja, más destacada que el resto
      else if (esUltimoPunto) {
        svgPath = `
          <svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56">
            <circle cx="28" cy="28" r="27" fill="#fff" stroke="#dc3545" stroke-width="3"/>
            <line x1="28" y1="44" x2="28" y2="12" stroke="#5a6268" stroke-width="2.5" stroke-linecap="round"/>
            <path d="M 28 12 L 28 28 L 46 20 Z" fill="#dc3545" stroke="#c82333" stroke-width="1.5"/>
            <circle cx="28" cy="44" r="3" fill="#dc3545"/>
          </svg>
        `;
      }
      // SVG de Stop (velocidad = 0)
      else if (velocidad === 0) {
        svgPath = `
          <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40">
            <polygon points="20,4 32,12 32,28 20,36 8,28 8,12" 
              fill="#dc3545" 
              stroke="#fff" 
              stroke-width="2"/>
            <text x="20" y="25" text-anchor="middle" fill="#fff" font-family="Arial, sans-serif" font-size="8" font-weight="bold">STOP</text>
          </svg>
        `;
      }
      // SVG de Vehículo en Movimiento (con dirección)
      else {
        const direccion = this.getDireccion(index);
        svgPath = `
          <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 60 60">
            <circle cx="15" cy="15" r="13.5" stroke="#ffffff" stroke-width="3" fill="#0066cc"></circle>
            <path fill="#ff4444" stroke="#ffffff" stroke-width="1.5" d="M 9 9 L 15 12 L 21 9 L 15 24 Z"
              transform="rotate(${direccion - 180}, 15, 15)"
            ></path>
          </svg>
        `;
      }

      const encodedPath = encodeURIComponent(svgPath);
      const iconUrl = "data:image/svg+xml;charset=UTF-8," + encodedPath;

      // Inicio (bandera verde) y final (bandera roja): más grandes; resto de puntos: tamaño normal
      const isInicio = esPrimerPunto;
      const isFinal = esUltimoPunto;
      const isDestacado = isInicio || isFinal;
      const scale = isDestacado ? 1.35 : 0.8;
      const anchor = isDestacado
        ? new google.maps.Point(28, 28)
        : new google.maps.Point(20, 20);

      return {
        url: iconUrl,
        fillColor: isInicio ? "#28a745" : isFinal ? "#dc3545" : "#b0c442",
        fillOpacity: 1,
        strokeColor: isInicio ? "#1e7e34" : isFinal ? "#c82333" : "#00529c",
        strokeWeight: isDestacado ? 2 : 1,
        strokeOpacity: 0.7,
        rotation: 0,
        scale,
        anchor,
      };
    },

    limpiarMapa() {
      this.puntosTraza = [];
      this.markersTraza = [];
      this.infoWinOpen = false;
    },

    centrarMapaDefault() {
      this.center = {
        lat: 4.651371,
        lng: -74.071509,
      };

      this.zoom = 6;

      this.infoWinOpen = false;
    },

    /**
     * Coordenadas del API → { lat, lng } o null si no son un punto GPS válido.
     * Acepta alias (lat/latitude/latitud, lon/lng/longitude/longitud).
     */
    normalizarLatLngDesdeMarcador(marcador) {
      if (!marcador || typeof marcador !== "object") return null;
      const rawLat = marcador.lat ?? marcador.latitude ?? marcador.latitud;
      const rawLng =
        marcador.lon ?? marcador.lng ?? marcador.longitude ?? marcador.longitud;
      if (rawLat == null || rawLng == null || rawLat === "" || rawLng === "") {
        return null;
      }
      const toNum = (v) => {
        if (typeof v === "number" && Number.isFinite(v)) return v;
        const s = String(v)
          .trim()
          .replace(",", ".");
        const n = parseFloat(s);
        return Number.isFinite(n) ? n : NaN;
      };
      const lat = toNum(rawLat);
      const lng = toNum(rawLng);
      if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
      if (lat < -90 || lat > 90 || lng < -180 || lng > 180) return null;
      return { lat, lng };
    },

    /** Convierte respuesta a forma Laravel paginator; evita prop `data` tipo Array en laravel-vue-pagination. */
    normalizarRespuestaPaginacion(raw, page) {
      if (raw == null) return {};
      if (Array.isArray(raw)) {
        const total = raw.length;
        return {
          data: raw,
          current_page: page,
          last_page: 1,
          per_page: total || 1,
          total,
          from: total ? 1 : 0,
          to: total,
        };
      }
      if (
        typeof raw === "object" &&
        Array.isArray(raw.items) &&
        raw.data == null
      ) {
        return { ...raw, data: raw.items };
      }
      return raw;
    },

    limpiarRutasTifTep() {
      this.det_ruta = [];
      this.polylines = {};
      this.mapKey++;
    },

    /** Limpia filtro legacy por bloque concreto (solo chips de bloque TEP/TIF). */
    applyBloqueBarraAlForm() {
      this.form.type_bloque = null;
      this.form.bloque_id = null;
    },

    onFiltroBloquesCapaChange() {
      this.infoWinOpen = false;
      this.showCarros();
      this.actualizarGeocercasBloques();
    },

    normalizarGpsFinDesdeApi(data) {
      if (data == null) {
        return null;
      }
      let o = data;
      if (typeof data === "string") {
        try {
          o = JSON.parse(data);
        } catch (e) {
          return null;
        }
      }
      return o.gps_fin || null;
    },

    mergeGpsFinIntoBloquesCapa(gps_fin, capPrefix, defaultFill) {
      if (!gps_fin) {
        return;
      }
      const polis = gps_fin.geocerca_poli || [];
      polis.forEach((geocerca) => {
        if (!geocerca.puntos || !geocerca.puntos.length) {
          return;
        }
        const puntos = [];
        geocerca.puntos.forEach((punto) => {
          puntos.push({
            lng: parseFloat(punto.longitud),
            lat: parseFloat(punto.latitud),
          });
        });
        const idNum = geocerca.id != null ? geocerca.id : capPrefix + "-" + puntos[0].lat;
        this.poligonosBloquesCapa.push({
          _vueKey: `${capPrefix}-poly-${idNum}`,
          id: `${capPrefix}-${idNum}`,
          name: geocerca.desc,
          path: puntos,
          info: geocerca.ventana || "",
          color: geocerca.color || defaultFill,
        });
      });
      const circs = gps_fin.geocerca_cir || [];
      circs.forEach((cir, j) => {
        if (cir.lat === "" || cir.lat == null) {
          return;
        }
        const fill = cir.color || defaultFill;
        this.circunferenciasBloquesCapa.push({
          _vueKey: `${capPrefix}-cir-${j}-${cir.lat}-${cir.lon}`,
          center: {
            lat: parseFloat(cir.lat),
            lng: parseFloat(cir.lon),
          },
          radius: parseFloat(cir.radio),
          info: cir.ventana,
          color: fill,
        });
      });
    },

    async actualizarGeocercasBloques() {
      this.poligonosBloquesCapa = [];
      this.circunferenciasBloquesCapa = [];
      if (!this.form.filtro_bloques_tep && !this.form.filtro_bloques_tif) {
        this.$nextTick(() => {
          this.mapKey++;
        });
        return;
      }
      try {
        const tareas = [];
        if (this.form.filtro_bloques_tep) {
          tareas.push(
            axios.get("/api/tep/mapas/showGeocercasZona").then((res) => {
              const gps = this.normalizarGpsFinDesdeApi(res.data);
              this.mergeGpsFinIntoBloquesCapa(gps, "tep-bloque", "#f59e0b");
            }),
          );
        }
        if (this.form.filtro_bloques_tif) {
          tareas.push(
            axios.get("/api/tif/mapas/showGeocercas").then((res) => {
              const gps = this.normalizarGpsFinDesdeApi(res.data);
              this.mergeGpsFinIntoBloquesCapa(gps, "tif-bloque", "#2563eb");
            }),
          );
        }
        await Promise.all(tareas);
      } catch (e) {
        this.$swal({
          icon: "error",
          title: "No se pudieron cargar geocercas de bloques",
          text: String(e && e.message ? e.message : e),
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 4000,
          timerProgressBar: true,
        });
      }
      this.$nextTick(() => {
        this.mapKey++;
      });
    },

    /**
     * Recalcula `this.form` usando filtros actuales (sin refrescar marcadores).
     * Se usa para cargar rutas sin llamar `showCarros()`.
     */
    hidratarFormDesdeFiltros() {
      const filters = this.$refs.MapasOptions?.filter ?? {};
      const filterTable = this.$refs.MapasListVehiculos?.filtros ?? {};
      const filterInactivos =
        this.$refs.MapasListVehiculos?.filterInactivos ?? {};

      this.form = {
        ...this.form,
        ...filters,
        ...filterTable,
        vh_filter_inactivos: filterInactivos.vhFilter ?? "",
        rem_filter_inactivos: filterInactivos.remFilter ?? "",
        trans_filter_inactivos: filterInactivos.transFilter ?? "",
      };
      this.applyBloqueBarraAlForm();
    },

    /**
     * Se ejecuta al togglear chips "Rutas Tep/Tif".
     * Carga/limpia SOLO polilíneas (no llama `showCarros`).
     */
    async onToggleRutasTifTep() {
      const rutasActivas = this.form.rutasTep || this.form.rutasTif;
      if (!rutasActivas) {
        this.limpiarRutasTifTep();
        return;
      }

      this.hidratarFormDesdeFiltros();

      this.cargando = true;
      try {
        const { data } = await axios.get(
          "/api/funcionariosFrontera/centralTrafico/mapa/rutasTifTepCs",
          {
            params: { ...this.form, page: 1 },
          },
        );
        await this.actualizarRutasTifTepDesdeIndex(data);
      } catch (error) {
        this.$swal({
          icon: "error",
          title: "Ocurrió un error: " + error,
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });
      } finally {
        this.cargando = false;
      }
    },

    /**
     * Construye/pinta las rutas (TIF/TEP) a partir de la respuesta de `indexTifTepCs`.
     * No hace request: solo interpreta `data`.
     */
    async actualizarRutasTifTepDesdeIndex(data) {
      const rutasActivas = this.form.rutasTep || this.form.rutasTif;
      if (!rutasActivas) {
        this.limpiarRutasTifTep();
        return;
      }

      const detRuta = data?.rutas ?? [];

      this.det_ruta = Array.isArray(detRuta) ? detRuta : [];
      if (this.det_ruta.length > 0) {
        await this.RutaPolilineas();
      } else {
        this.limpiarRutasTifTep();
      }
    },

    /**
     * Placas elegidas en el modal (v-select taggable): strings u objetos con placa.
     */
    placasDesdeFiltroModalVehiculo(vehiculo) {
      if (vehiculo == null || vehiculo === "") {
        return [];
      }
      const items = Array.isArray(vehiculo) ? vehiculo : [vehiculo];
      const out = [];
      items.forEach((item) => {
        if (typeof item === "string") {
          const p = item.trim().toUpperCase();
          if (p) out.push(p);
        } else if (item && typeof item === "object" && item.placa) {
          const p = String(item.placa).trim().toUpperCase();
          if (p) out.push(p);
        }
      });
      return [...new Set(out)];
    },

    /**
     * Tras buscar con una sola placa en el modal: centrar mapa y abrir trazabilidad (período "hoy" si faltan fechas).
     */
    sincronizarPlacaModalConTrazabilidad(mapModalFilter) {
      const placas = this.placasDesdeFiltroModalVehiculo(
        mapModalFilter && mapModalFilter.vehiculo,
      );
      if (placas.length !== 1) {
        return;
      }
      const placa = placas[0];
      const hit = this.markers.find(
        (m) =>
          m.placa &&
          String(m.placa).trim().toUpperCase() === placa,
      );
      if (hit && hit.position) {
        const lat = Number(hit.position.lat);
        const lng = Number(hit.position.lng);
        if (Number.isFinite(lat) && Number.isFinite(lng)) {
          this.center = { lat, lng };
          this.zoom = 14;
        }
      }
      this.filter.buscar_por = "Placa";
      this.filter.placa = placa;

      const teniaFechas =
        !!this.filter.fecha_inicio &&
        !!this.filter.fecha_fin &&
        !!this.filter.hora_inicio &&
        !!this.filter.hora_fin;

      this.trazaViaje = true;
      this.$nextTick(() => {
        this.showDraggable();
        if (!teniaFechas) {
          this.setPeriodo("hoy");
        } else if (this.$v.filter && !this.$v.filter.$invalid) {
          this.showTraza();
        }
      });
    },

    pintarMarcadoresEnChunks(marcadores) {
      const chunkSize = 80;
      const me = this;
      const gen = this._mapaPaintGen;
      return new Promise(function (resolve) {
        let i = 0;
        const pintarChunk = function () {
          if (gen !== me._mapaPaintGen) {
            resolve();
            return;
          }
          const end = Math.min(i + chunkSize, marcadores.length);
          for (; i < end; i++) {
            const marcador = marcadores[i];
            const coords = me.normalizarLatLngDesdeMarcador(marcador);
            if (!coords) {
              continue;
            }
            me.markers.push({
              placa: marcador.desc || null,
              position: coords,
              icon: me.getSvgIcon(marcador),
              info: marcador.ventana,
            });
          }
          if (i < marcadores.length) {
            if (window.requestAnimationFrame) {
              window.requestAnimationFrame(pintarChunk);
            } else {
              setTimeout(pintarChunk, 0);
            }
          } else {
            resolve();
          }
        };
        pintarChunk();
      });
    },

    async showCarros(page = 1) {
      this._mapaPaintGen = (this._mapaPaintGen || 0) + 1;
      this.centrarMapaDefault();
      this.markers = [];
      const mapOpts = this.$refs.MapasOptions;
      let filters = {};
      if (mapOpts && mapOpts.filter) {
        try {
          filters = JSON.parse(JSON.stringify(mapOpts.filter));
        } catch (e) {
          filters = { ...mapOpts.filter };
        }
      }
      const plsBar = this.placasDesdeFiltroModalVehiculo(filters.vehiculo);
      if (plsBar.length === 1) {
        this.mapQuickPlaca = plsBar[0];
      } else if (plsBar.length > 1) {
        this.mapQuickPlaca = "";
      }
      const filterTable = this.$refs.MapasListVehiculos?.filtros ?? {};
      const filterInactivos =
        this.$refs.MapasListVehiculos?.filterInactivos ?? {};
      if (filters.geocerca != null) {
        this.filterResult(filters.geocerca);
      }
      this.form = {
        ...this.form,
        ...filters,
        ...filterTable,
        vh_filter_inactivos: filterInactivos.vhFilter ?? "",
        rem_filter_inactivos: filterInactivos.remFilter ?? "",
        trans_filter_inactivos: filterInactivos.transFilter ?? "",
      };
      this.applyBloqueBarraAlForm();
      this.cargando = true;
      try {
        const { data } = await axios.get(
          "/api/funcionariosFrontera/centralTrafico/mapa/indexTifTepCs",
          {
            params: { ...this.form, page },
          },
        );
        const marcadores = data.marcadores;
        this.conteoGeneral = data.conteoGeneral;
        this.dataPaginaActivos = this.normalizarRespuestaPaginacion(
          data.dataPaginaActivos,
          page,
        );
        this.dataPaginaInactivos = this.normalizarRespuestaPaginacion(
          data.dataPaginaInactivos,
          page,
        );

        this.cargando = false;
        if (Array.isArray(marcadores) && marcadores.length > 0) {
          await this.pintarMarcadoresEnChunks(marcadores);
        }
        this.$nextTick(() => {
          this.updateChipsScrollButtons();
          this.sincronizarPlacaModalConTrazabilidad(filters);
        });
      } catch (error) {
        this.cargando = false;
        this.$swal({
          icon: "error",
          title: "Ocurrió un error: " + error,
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });
      }
    },

    filterResult(geo) {
      for (let i = 0; i < this.poligonos.length; i++) {
        if (this.poligonos[i].id == geo.id) {
          const marker = {
            lat: parseFloat(this.poligonos[i].path[0].lat),
            lng: parseFloat(this.poligonos[i].path[0].lng),
          };
          this.markersTraza.push({
            position: marker,
            info: this.poligonos[i].info,
          });
          this.center = marker;
          this.zoom = 15;
        }
      }
    },

    cleanMarkers() {
      this.markersTraza = [];
    },

    getSvgIcon(data) {
      const google = window.google;

      const path = `
        <svg xmlns="http://www.w3.org/2000/svg" width="80" height="30">
          <circle cx="13" cy="13.5" r="13" stroke="white" stroke-width="2" fill="${
            data.icon_color
          }"></circle>
          <path 
            fill="#b0c442"
            stroke="white" 
            stroke-width="1" 
            d="M 7 7 L 13 11 L 19 7 L 13 21 Z" 
            transform="rotate(${
              data.direccion ? data.direccion - 180 : -180
            }, 13, 13)">
          </path>
          <rect width="39" height="15" fill="black" stroke="black" x="26" y="6"></rect>
          <text font-size="10" font-family="" x="28" y="16" fill="white">
            ${data.desc}
          </text>
        </svg>
      `;
      const encodedPath = encodeURIComponent(path);
      const iconUrl = "data:image/svg+xml;charset=UTF-8," + encodedPath;

      return {
        url: iconUrl,
        fillColor: "#b0c442",
        fillOpacity: 1,
        strokeColor: "#00529c",
        strokeWeight: 1,
        strokeOpacity: 0.7,
        rotation: data.direccion ? data.direccion - 180 : -180,
        scale: 0.7,
        anchor: new google.maps.Point(15, 30),
      };
    },

    async showGeocercas() {
      if (await this.form.geocercas) {
        this.cargando = true;
        await axios
          .get("/api/hidrocarburos/mapas/showGeocercas")
          .then((response) => {
            this.cargando = false;
            this.locations = response.data.gps_fin;
            this.locations.geocerca_poli.forEach((geocerca) => {
              if (geocerca.puntos.length > 0) {
                let puntos = [];
                geocerca.puntos.forEach((punto) => {
                  puntos.push({
                    lng: parseFloat(punto.longitud),
                    lat: parseFloat(punto.latitud),
                  });
                });

                this.poligonos.push({
                  id: geocerca.id,
                  name: geocerca.desc,
                  path: puntos,
                  info: geocerca.ventana,
                  color: geocerca.color,
                });
              }
            });
            for (var j = 0; j < this.locations.geocerca_cir.length; j++) {
              if (this.locations.geocerca_cir[j]["lat"] !== "") {
                this.circunferencias.push({
                  center: {
                    lat: parseFloat(this.locations.geocerca_cir[j]["lat"]),
                    lng: parseFloat(this.locations.geocerca_cir[j]["lon"]),
                  },
                  radius: parseFloat(this.locations.geocerca_cir[j]["radio"]),
                  info: this.locations.geocerca_cir[j]["ventana"],
                });
              }
            }
          })
          .catch(function(error) {
            this.cargando = false;
          });
      } else {
        this.locations = {};
        this.circunferencias = [];
        this.poligonos = [];
      }
    },

    async showGeocercasProhibidas() {
      if (await this.form.geocercasProhibidas) {
        this.cargando = true;
        await axios
          .get("/api/hidrocarburos/mapas/showGeocercasProhibidas")
          .then((response) => {
            this.cargando = false;
            this.locations = response.data.gps_fin;
            this.locations.geocerca_poli.forEach((geocerca) => {
              if (geocerca.puntos.length > 0) {
                let puntos = [];
                geocerca.puntos.forEach((punto) => {
                  puntos.push({
                    lng: parseFloat(punto.longitud),
                    lat: parseFloat(punto.latitud),
                  });
                });

                this.poligonos.push({
                  id: geocerca.id,
                  name: geocerca.desc,
                  path: puntos,
                  info: geocerca.ventana,
                  color: geocerca.color,
                });
              }
            });
            for (var j = 0; j < this.locations.geocerca_cir.length; j++) {
              if (this.locations.geocerca_cir[j]["lat"] !== "") {
                this.circunferencias.push({
                  center: {
                    lat: parseFloat(this.locations.geocerca_cir[j]["lat"]),
                    lng: parseFloat(this.locations.geocerca_cir[j]["lon"]),
                  },
                  radius:
                    parseFloat(this.locations.geocerca_cir[j]["radio"]) * 1000,
                  info: this.locations.geocerca_cir[j]["ventana"],
                });
              }
            }
          })
          .catch(function(error) {
            this.cargando = false;
          });
      } else {
        this.locations = {};
        this.circunferencias = [];
        this.poligonos = [];
      }
    },

    toggleInfoWindow: function(marker, idx, ventana) {
      this.infoWindowPos = marker.position;
      this.infoContent = ventana;
      this.center = marker.position;

      //comprueba si es el mismo marcador que se seleccionó y en caso afirmativo alternar
      if (this.currentMidx == idx) {
        this.infoWinOpen = !this.infoWinOpen;
      }
      //si un marcador diferente establece la ventana de información para abrir y restablecer el índice de marcador actual
      else {
        this.infoWinOpen = true;
        this.currentMidx = idx;
      }
    },

    toggleInfoWindowPoli: function(poli, idx, ventana) {
      this.infoWindowPos = poli.path[0];
      this.infoContent = ventana;
      this.center = poli.path[0];

      //compruebe si es el mismo marcador que se seleccionó y en caso afirmativo alternar
      if (this.currentMidx == idx) {
        this.infoWinOpen = !this.infoWinOpen;
      }
      //si un marcador diferente establece la ventana de información para abrir y restablecer el índice de marcador actual
      else {
        this.infoWinOpen = true;
        this.currentMidx = idx;
      }
    },

    toggleInfoWindowCir: function(cir, idx, ventana) {
      this.infoWindowPos = cir.center;
      this.infoContent = ventana;
      this.center = cir.center;

      //compruebe si es el mismo marcador que se seleccionó y en caso afirmativo alternar
      if (this.currentMidx == idx) {
        this.infoWinOpen = !this.infoWinOpen;
      }
      //si un marcador diferente establece la ventana de información para abrir y restablecer el índice de marcador actual
      else {
        this.infoWinOpen = true;
        this.currentMidx = idx;
      }
    },

    // ==================== MÉTODOS RELACIONADOS CON LA VENTANA FLOTANTE ====================
    // Métodos para el arrastre de la ventana flotante
    startDrag(event) {
      // Solo permitir arrastre desde el header
      if (!event.target.closest(".floating-header")) return;

      this.isDragging = true;
      this.dragOffset.x = event.clientX - this.windowPosition.x;
      this.dragOffset.y = event.clientY - this.windowPosition.y;

      document.addEventListener("mousemove", this.onDrag);
      document.addEventListener("mouseup", this.stopDrag);

      // Prevenir selección de texto durante el arrastre
      event.preventDefault();
    },

    onDrag(event) {
      if (!this.isDragging) return;

      const newX = event.clientX - this.dragOffset.x;
      const newY = event.clientY - this.dragOffset.y;

      // Limitar el movimiento dentro de los límites de la ventana
      const maxX = window.innerWidth - 600; // Ancho de la ventana
      const maxY = window.innerHeight - 200; // Altura mínima visible

      this.windowPosition.x = Math.max(0, Math.min(newX, maxX));
      this.windowPosition.y = Math.max(0, Math.min(newY, maxY));
    },

    stopDrag() {
      this.isDragging = false;
      document.removeEventListener("mousemove", this.onDrag);
      document.removeEventListener("mouseup", this.stopDrag);
    },

    onPlacaChange() {
      // Limpiar timeout anterior si existe
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
        this.searchTimeout = null;
      }

      // Búsqueda automática si hay período seleccionado y placa (solo para fechas rápidas)
      if (
        this.filter.placa &&
        this.filter.periodo &&
        this.filter.periodo !== "personalizado"
      ) {
        // Pequeño delay para evitar búsquedas excesivas mientras el usuario escribe
        this.searchTimeout = setTimeout(() => {
          this.showTraza();
        }, 1000);
      }
    },

    setPeriodo(periodo) {
      this.$set(this.filter, "periodo", periodo);

      const ahora = new Date();
      const hoy = new Date(
        ahora.getFullYear(),
        ahora.getMonth(),
        ahora.getDate(),
      );

      // Configurar límites según el período para optimizar consultas
      //let limiteRegistros = 1000; // Por defecto
      let mensajeTiempo = "Carga rápida";

      switch (periodo) {
        case "hoy":
          //limiteRegistros = 1000;
          mensajeTiempo = "Carga rápida (< 5 segundos)";
          this.$set(this.filter, "fecha_inicio", this.formatDate(hoy));
          this.$set(this.filter, "hora_inicio", "00:00");
          this.$set(this.filter, "fecha_fin", this.formatDate(hoy));
          this.$set(this.filter, "hora_fin", "23:59");
          break;

        case "ayer": {
          //limiteRegistros = 2000;
          mensajeTiempo = "Carga moderada (< 10 segundos)";
          const ayer = new Date(hoy);
          ayer.setDate(ayer.getDate() - 1);
          this.$set(this.filter, "fecha_inicio", this.formatDate(ayer));
          this.$set(this.filter, "hora_inicio", "00:00");
          this.$set(this.filter, "fecha_fin", this.formatDate(ayer));
          this.$set(this.filter, "hora_fin", "23:59");
          break;
        }
        case "semana": {
          //limiteRegistros = 5000;
          mensajeTiempo = "Carga lenta (< 30 segundos)";
          const semanaAtras = new Date(hoy);
          semanaAtras.setDate(semanaAtras.getDate() - 7);
          this.$set(this.filter, "fecha_inicio", this.formatDate(semanaAtras));
          this.$set(this.filter, "hora_inicio", "00:00");
          this.$set(this.filter, "fecha_fin", this.formatDate(hoy));
          this.$set(this.filter, "hora_fin", "23:59");
          break;
        }
        case "mes": {
          //limiteRegistros = 10000;
          mensajeTiempo = "Carga muy lenta (< 60 segundos)";
          const mesAtras = new Date(hoy);
          mesAtras.setMonth(mesAtras.getMonth() - 1);
          this.$set(this.filter, "fecha_inicio", this.formatDate(mesAtras));
          this.$set(this.filter, "hora_inicio", "00:00");
          this.$set(this.filter, "fecha_fin", this.formatDate(hoy));
          this.$set(this.filter, "hora_fin", "23:59");
          break;
        }
        case "personalizado": {
          // Limpiar fechas para que el usuario las configure manualmente
          //this.$set(this.filter, "fecha_inicio", null);
          const ayerPersonalizado = new Date(hoy);
          ayerPersonalizado.setDate(ayerPersonalizado.getDate() - 1);
          this.$set(
            this.filter,
            "fecha_inicio",
            this.formatDate(ayerPersonalizado),
          );
          this.$set(this.filter, "hora_inicio", "00:00");
          //this.$set(this.filter, "fecha_fin", null);
          this.$set(this.filter, "fecha_fin", this.formatDate(hoy));
          this.$set(this.filter, "hora_fin", "23:59");
          // Limpiar timeout de búsqueda automática
          if (this.searchTimeout) {
            clearTimeout(this.searchTimeout);
            this.searchTimeout = null;
          }
          break;
        }
      }

      // Agregar límites y mensaje de tiempo al filter
      //this.$set(this.filter, "limite_registros", limiteRegistros);
      this.$set(this.filter, "mensaje_tiempo", mensajeTiempo);

      // Si hay placa, hacer búsqueda automática
      if (this.filter.placa && periodo !== "personalizado") {
        this.showTraza();
      }
    },

    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },

    shiftRangoFechas(deltaDias) {
      if (!this.filter.fecha_inicio || !this.filter.fecha_fin) return;

      const parseYmd = (ymd) => {
        const [y, m, d] = String(ymd)
          .split("-")
          .map((n) => parseInt(n, 10));
        if (!y || !m || !d) return null;
        return new Date(y, m - 1, d);
      };

      const ini = parseYmd(this.filter.fecha_inicio);
      const fin = parseYmd(this.filter.fecha_fin);
      if (!ini || !fin) return;

      const ini2 = new Date(ini);
      const fin2 = new Date(fin);
      ini2.setDate(ini2.getDate() + deltaDias);
      fin2.setDate(fin2.getDate() + deltaDias);

      // No permitir que el fin pase de hoy
      const hoy = new Date();
      const hoy0 = new Date(hoy.getFullYear(), hoy.getMonth(), hoy.getDate());
      if (fin2 > hoy0) {
        const diff = Math.round((fin2 - hoy0) / (1000 * 60 * 60 * 24));
        ini2.setDate(ini2.getDate() - diff);
        fin2.setDate(fin2.getDate() - diff);
      }

      this.$set(this.filter, "fecha_inicio", this.formatDate(ini2));
      this.$set(this.filter, "fecha_fin", this.formatDate(fin2));
      this.validaFechas();

      // Si ya hay una placa, refrescar automáticamente la trazabilidad
      if (
        this.filter.buscar_por === "Placa" &&
        this.filter.placa &&
        this.filter.hora_inicio &&
        this.filter.hora_fin
      ) {
        this.showTraza();
      }
    },

    limpiarForm() {
      this.filter.placa = null;
      this.filter.fecha_inicio = null;
      this.filter.fecha_fin = null;
      this.filter.hora_inicio = null;
      this.filter.hora_fin = null;
      this.filter.viaje_id = null;
      this.filter.mensaje_tiempo = null;
      this.filter.limite_registros = null;
      this.filter.periodo = null;
      this.vehiculoTraza = null;
      this.markersTraza = [];
      this.puntosTraza = [];
      this.markersPuntosNovedad = [];
      this._trazaPaintGen = (this._trazaPaintGen || 0) + 1;
      if (this.polylines && this.polylines.trazaVehiculo) {
        this.$delete(this.polylines, "trazaVehiculo");
      }
      this.center = { lat: 4.651371, lng: -74.071509 };
      this.zoom = 6;
      this.infoWinOpen = false;
    },

    showTraza() {
      // Método para mostrar la trazabilidad de un vehículo optimizada
      this.cargando = true;
      this.vehiculoTraza = null;
      this.markersTraza = [];
      this.puntosTraza = [];
      this.markersPuntosNovedad = [];
      this._trazaPaintGen = (this._trazaPaintGen || 0) + 1;
      if (this.polylines && this.polylines.trazaVehiculo) {
        this.$delete(this.polylines, "trazaVehiculo");
      }
      this.center = { lat: 4.651371, lng: -74.071509 };
      this.zoom = 6;

      // Mostrar mensaje de progreso según el período
      let mensajeProgreso = "Buscando trazabilidad...";
      if (this.filter.mensaje_tiempo) {
        mensajeProgreso = `Buscando trazabilidad - ${this.filter.mensaje_tiempo}`;
      }

      const swalMsg = this.$swal({
        title: mensajeProgreso,
        text:
          this.filter.buscar_por === "Placa"
            ? `Período: ${this.filter.fecha_inicio} ${this.filter.hora_inicio} - ${this.filter.fecha_fin} ${this.filter.hora_fin}`
            : this.filter.buscar_por === "TepTurno"
            ? `Tep Turno: ${this.filter.turno_id}`
            : this.filter.buscar_por === "TifTurno"
            ? `Tif Turno: ${this.filter.turno_id}`
            : this.filter.buscar_por === "TepViaje"
            ? `Tep Viaje: ${this.filter.viaje_id}`
            : null,

        icon: "info",
        allowOutsideClick: false,
        showConfirmButton: false,
      });

      axios
        .get(
          "/api/funcionariosFrontera/centralTrafico/mapa/trazaViajeTifTepCs",
          {
            params: this.filter,
          },
        )
        .then((response) => {
          this.cargando = false;
          swalMsg.close(); // Cerrar modal de progreso

          if (!response.data.mensaje) {
            if (response.data.arregloViaje) {
              this.filter.vehiculo_id = "";
              this.puntosTraza = response.data.arregloViaje;
              this.vehiculoTraza = response.data.vehiculoTraza;

              this.aplicarNovedadesATraza(response.data.novedadesEnRuta || []);

              if (this.puntosTraza.length > 0) {
                this.getTrazaSegmentada();
                this.$nextTick(() => {
                  this.mapKey++;
                });
              } else {
                this.$swal({
                  icon: "error",
                  title:
                    "No existe traza para este Vehículo en las fechas seleccionadas.",
                  toast: true,
                  position: "top-end",
                  timer: 3500,
                  timerProgressBar: true,
                  showConfirmButton: false,
                });
              }
            }
          } else {
            this.$swal({
              icon: "error",
              title: response.data.mensaje,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3500,
              timerProgressBar: true,
            });
            return false;
          }
        })
        .catch((error) => {
          this.cargando = false;
          swalMsg.close(); // Cerrar modal de progreso
          this.$swal({
            icon: "error",
            title: "Ocurrió un error: " + error,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        });
    },

    validaFechas() {
      if (
        this.filter.fecha_inicio &&
        this.filter.hora_inicio &&
        this.filter.fecha_fin &&
        this.filter.hora_inicio
      ) {
        const fecha_menor = new Date(
          this.filter.fecha_inicio + " " + this.filter.hora_inicio,
        );
        const fecha_mayor = new Date(
          this.filter.fecha_fin + " " + this.filter.hora_fin,
        );

        // Se valida que la fecha inicial sea menor que la fecha final
        if (fecha_menor > fecha_mayor) {
          this.filter.fecha_fin = null;
          this.filter.hora_fin = null;
          this.$swal({
            icon: "error",
            title: `La Fecha Inicio no puede ser mayor a la Fecha Fin...`,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
          return false;
        }

        // Se valida que la diferencia de días no superea 5 días
        const diff = fecha_mayor - fecha_menor;
        const fecha_limite = diff / (1000 * 60 * 60 * 24);
        if (fecha_limite > this.dias_limite) {
          this.filter.fecha_fin = null;
          this.filter.hora_fin = null;
          this.$swal({
            icon: "error",
            title: `Las diferencia de fechas no puede ser mayor a ${this.dias_limite} días...`,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
          return false;
        }
      }
    },
    // ==================== MÉTODOS RELACIONADOS CON LA VENTANA FLOTANTE ====================

    // ==================== MÉTODOS RELACIONADOS CON COMPONENTES HIJOS ====================
    onUpdateRutasPolylines(polylinesObj) {
      this.polylinesRutasTramos = polylinesObj || {};
      this.mapKey++;
    },

    escHtmlInfoTramo(s) {
      if (s == null || s === "") return "";
      return String(s)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;");
    },

    formatHoraInfoTramo(t) {
      if (t == null || t === "") return "—";
      const s = String(t);
      if (s.length >= 16 && s.includes(" ")) {
        return s.slice(11, 16);
      }
      if (s.length >= 5 && s.indexOf(":") >= 0) {
        return s.slice(0, 5);
      }
      return s;
    },

    labelDiaSemanaInfoTramo(d) {
      if (d == null || d === "") return "—";
      const n = parseInt(d, 10);
      const labels = ["—", "Lun", "Mar", "Mié", "Jue", "Vie", "Sáb", "Dom"];
      if (Number.isFinite(n) && n >= 1 && n <= 7) {
        return labels[n];
      }
      return this.escHtmlInfoTramo(d);
    },

    textoVelMaxInfoTramo(tramo) {
      const v = tramo && (tramo.vel_max ?? tramo.velMax);
      if (v == null || String(v).trim() === "") {
        return null;
      }
      const s = String(v).trim();
      if (/^\d+(\.\d+)?$/.test(s)) {
        return `${s} km/h`;
      }
      return this.escHtmlInfoTramo(s);
    },

    htmlInfoVentanaTramo(nombreRuta, tramo) {
      const r = this.escHtmlInfoTramo(nombreRuta || "Ruta");
      const t = this.escHtmlInfoTramo((tramo && (tramo.nombre || tramo.Nombre)) || "Tramo");
      const velTxt = this.textoVelMaxInfoTramo(tramo);
      const dist = tramo && (tramo.distancia_km ?? tramo.distanciaKm);
      const distTxt =
        dist != null && String(dist).trim() !== ""
          ? this.escHtmlInfoTramo(String(dist).trim()) + " km"
          : null;

      const horariosRaw = (tramo && (tramo.horarios || tramo.Horarios)) || [];
      const horarios = Array.isArray(horariosRaw) ? horariosRaw : [];

      let filasHorario = "";
      if (horarios.length === 0) {
        filasHorario = `<tr><td colspan="3" style="padding:10px 8px;color:#64748b;font-size:12px;">Sin horarios registrados para este tramo.</td></tr>`;
      } else {
        horarios.forEach((h) => {
          const dia = this.labelDiaSemanaInfoTramo(h.dia_semana ?? h.diaSemana);
          const hi = this.formatHoraInfoTramo(h.horario_ini ?? h.horarioIni);
          const hf = this.formatHoraInfoTramo(h.horario_fin ?? h.horarioFin);
          const obs = h.observacion;
          const obsEsc = obs ? this.escHtmlInfoTramo(obs) : "";
          filasHorario += `<tr style="border-top:1px solid #e2e8f0;">
            <td style="padding:8px;font-weight:600;color:#0f172a;font-size:12px;">${dia}</td>
            <td style="padding:8px;font-size:12px;color:#334155;">${this.escHtmlInfoTramo(hi)} – ${this.escHtmlInfoTramo(hf)}</td>
            <td style="padding:8px;font-size:11px;color:#64748b;">${obsEsc || "—"}</td>
          </tr>`;
        });
      }

      const chipVel = velTxt
        ? `<span style="display:inline-block;background:#ecfdf5;color:#065f46;padding:6px 12px;border-radius:999px;font-size:13px;font-weight:600;border:1px solid #a7f3d0;">Vel. máx. ${this.escHtmlInfoTramo(velTxt)}</span>`
        : `<span style="display:inline-block;background:#f1f5f9;color:#475569;padding:6px 12px;border-radius:999px;font-size:12px;">Vel. máx. no definida</span>`;
      const chipDist = distTxt
        ? `<span style="display:inline-block;margin-left:8px;background:#eff6ff;color:#1e40af;padding:6px 12px;border-radius:999px;font-size:12px;font-weight:600;border:1px solid #bfdbfe;">Dist. ${distTxt}</span>`
        : "";

      return `<div style="font-family:system-ui,-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif;min-width:260px;max-width:320px;border-radius:12px;overflow:hidden;box-shadow:0 8px 24px rgba(15,23,42,0.12);">
        <div style="background:linear-gradient(135deg,#047857,#059669);color:#fff;padding:12px 14px;">
          <div style="font-size:11px;opacity:0.9;letter-spacing:0.02em;">${r}</div>
          <div style="font-size:16px;font-weight:700;margin-top:4px;line-height:1.25;">${t}</div>
        </div>
        <div style="padding:12px 14px;background:#fff;">
          <div style="margin-bottom:12px;display:flex;flex-wrap:wrap;align-items:center;">${chipVel}${chipDist}</div>
          <div style="font-size:11px;font-weight:700;color:#64748b;text-transform:uppercase;letter-spacing:0.06em;margin-bottom:6px;">Horarios permitidos</div>
          <table style="width:100%;border-collapse:collapse;font-size:12px;">
            <thead>
              <tr style="background:#f8fafc;color:#475569;">
                <th style="text-align:left;padding:6px 8px;border-radius:6px 0 0 0;">Día</th>
                <th style="text-align:left;padding:6px 8px;">Horario</th>
                <th style="text-align:left;padding:6px 8px;border-radius:0 6px 0 0;">Nota</th>
              </tr>
            </thead>
            <tbody>${filasHorario}</tbody>
          </table>
        </div>
      </div>`;
    },

    /**
     * Path del tramo para el mapa: prioriza `waypoints` (JSON guardado en
     * admin TEP/TIF con puntos por la vía), luego `det_*_tramos_rutas`, y
     * por último recta origen → destino.
     */
    construirPathTramoDesdeModelo(tramo) {
      if (!tramo) return [];

      const rawWp = tramo.waypoints;
      if (rawWp) {
        let pts;
        try {
          pts = typeof rawWp === "string" ? JSON.parse(rawWp) : rawWp;
        } catch (e) {
          pts = null;
        }
        if (Array.isArray(pts) && pts.length >= 2) {
          const pathWp = [];
          pts.forEach((p) => {
            const lat = parseFloat(p.lat ?? p.latitude);
            const lng = parseFloat(p.lng ?? p.lon ?? p.longitude);
            if (Number.isFinite(lat) && Number.isFinite(lng)) {
              pathWp.push({ lat, lng });
            }
          });
          if (pathWp.length >= 2) {
            return pathWp;
          }
        }
      }

      const detalles =
        tramo.det_tramos_rutas ?? tramo.detTramosRutas ?? [];
      const path = [];
      if (Array.isArray(detalles) && detalles.length > 0) {
        const detallesOrdenados = [...detalles].sort(
          (a, b) => (a.orden || 0) - (b.orden || 0),
        );
        detallesOrdenados.forEach((detalle, dIdx) => {
          const dLatIni = parseFloat(detalle.lat_ini);
          const dLngIni = parseFloat(detalle.lon_ini);
          const dLatFin = parseFloat(detalle.lat_fin);
          const dLngFin = parseFloat(detalle.lon_fin);
          if (
            !Number.isFinite(dLatIni) ||
            !Number.isFinite(dLngIni) ||
            !Number.isFinite(dLatFin) ||
            !Number.isFinite(dLngFin)
          ) {
            return;
          }
          if (dIdx === 0) {
            path.push({ lat: dLatIni, lng: dLngIni });
          }
          path.push({ lat: dLatFin, lng: dLngFin });
        });
      }

      if (path.length >= 2) {
        return path;
      }

      const latIni = parseFloat(tramo.lat_origen ?? tramo.lat_ini ?? "");
      const lngIni = parseFloat(tramo.lng_origen ?? tramo.lon_origen ?? "");
      const latFin = parseFloat(tramo.lat_destino ?? tramo.lat_fin ?? "");
      const lngFin = parseFloat(tramo.lng_destino ?? tramo.lon_destino ?? "");
      if (
        Number.isFinite(latIni) &&
        Number.isFinite(lngIni) &&
        Number.isFinite(latFin) &&
        Number.isFinite(lngFin)
      ) {
        return [
          { lat: latIni, lng: lngIni },
          { lat: latFin, lng: lngFin },
        ];
      }
      return [];
    },

    async RutaPolilineas() {
      this.polylines = {};
      this.pathPoli = await this.det_ruta;

      for (let r = 0; r < this.pathPoli.length; r++) {
        const ruta = this.pathPoli[r];
        const color = this.colorsArray[r % this.colorsArray.length]; // selecciona un color diferente para cada polilínea

        const rutasTramos = ruta?.rutas_tramos ?? ruta?.rutasTramos ?? [];
        if (Array.isArray(rutasTramos) && rutasTramos.length > 0) {
          rutasTramos.forEach((rt, idx) => {
            const tramo = rt?.tramo_ruta ?? rt?.tramoRuta ?? null;
            if (!tramo) return;

            const path = this.construirPathTramoDesdeModelo(tramo);
            if (path.length < 2) {
              return;
            }

            const key = `ruta_${ruta.id}_tramo_${tramo.id ?? idx}`;
            this.$set(this.polylines, key, {
              path,
              options: {
                strokeColor: tramo.color || color,
                strokeOpacity: 0.85,
                strokeWeight: 5,
              },
              info: this.htmlInfoVentanaTramo(ruta.nombre || "Ruta", tramo),
            });
          });
        }
      }
      this.mapKey++; // aumenta la clave del mapa
    },

    toggleMapFullscreen() {
      this.mapFullscreen = !this.mapFullscreen;
      this.$nextTick(() => {
        // Forzar relayout del mapa al cambiar tamaño
        this.mapKey += 1;
      });
    },
    // ==================== FIN DE MÉTODOS RELACIONADOS CON COMPONENTES HIJOS ====================
  },

  beforeMount() {
    this.getRutas();
  },

  mounted() {
    this.initChipsScroller();
    window.addEventListener("resize", this.updateChipsScrollButtons, {
      passive: true,
    });
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.updateChipsScrollButtons);
    if (this.chipsResizeObserver) {
      this.chipsResizeObserver.disconnect();
      this.chipsResizeObserver = null;
    }
  },
};
</script>
<style>
/* Espacio entre el título de página y el mapa (evita sensación de solapamiento) */
.mapa-ff-mapa-page .content-header {
  padding-bottom: 0.75rem;
}

.mapa-ff-mapa-page .content .container-fluid > .row:first-child {
  margin-top: 2px;
}

/* Ventana flotante de trazabilidad - Funcionalidad única */
.trazabilidad-floating-window {
  position: fixed;
  width: 600px;
  max-width: 90vw;
  max-height: 90vh;
  z-index: 1050;
  background: white;
  border-radius: 8px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
  border: 1px solid #dee2e6;
  overflow: hidden;
  user-select: none;
  animation: slideInFromRight 0.3s ease-out;
}

.floating-window-content {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.floating-header {
  cursor: move;
}

.floating-body {
  overflow-y: auto;
  flex: 1;
  max-height: 85vh;
}

/* Arrastre activo */
.trazabilidad-floating-window.dragging {
  cursor: move;
  box-shadow: 0 12px 35px rgba(0, 0, 0, 0.25);
}

/* Animación de entrada */
@keyframes slideInFromRight {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

/* Pantalla completa del mapa - Funcionalidad única */
.map-wrapper.fullscreen {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 1040;
  background: #fff;
}

.map-fullscreen-btn {
  position: absolute;
  right: 12px;
  top: 12px;
  /* Por encima del overlay de búsqueda/chips (z-index 50) para que sea clicable */
  z-index: 60;
}

/* ===================== UI Overlay tipo Google Maps ===================== */
.map-wrapper {
  position: relative;
}

.map-overlay-ui {
  position: absolute;
  /* Más a la derecha: deja ver etiquetas del mapa a la izquierda (p. ej. nombres de sitios) */
  left: 200px;
  top: 6px;
  bottom: auto;
  right: auto;
  z-index: 50;
  pointer-events: none;
  width: fit-content;
  max-width: min(1240px, calc(100% - 200px - 56px));
}

.map-overlay-ui .map-overlay-top {
  pointer-events: auto;
}

.map-top-toolbar {
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: nowrap;
  gap: 10px;
  width: fit-content;
  max-width: min(1240px, calc(100% - 200px - 56px));
}

.map-overlay-bottom {
  display: none;
}

.map-overlay-top {
  display: flex;
  flex-direction: column;
  gap: 0;
  width: auto;
  max-width: 100%;
}

.map-searchbar {
  display: flex;
  align-items: center;
  gap: 6px;
  background: rgba(255, 255, 255, 0.42);
  -webkit-backdrop-filter: blur(14px) saturate(140%);
  backdrop-filter: blur(14px) saturate(140%);
  border-radius: 999px;
  border: 1px solid rgba(255, 255, 255, 0.55);
  padding: 6px 10px;
  min-height: 42px;
  height: auto;
  flex-wrap: nowrap;
  position: relative;
  flex: 0 0 auto;
  width: auto;
  min-width: 200px;
  max-width: min(320px, 34vw);
  box-shadow: 0 1px 8px rgba(15, 23, 42, 0.06);
}

.map-search-leading {
  border: none;
  background: transparent;
  width: 34px;
  height: 34px;
  border-radius: 999px;
  color: #111827;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.map-search-leading:hover {
  background: rgba(0, 0, 0, 0.06);
}

.map-search-input {
  border: none;
  outline: none;
  background: transparent;
  flex: 1;
  min-width: 72px;
  color: #111827;
  font-size: 14px;
  cursor: text;
  position: relative;
  z-index: 1;
}

.map-search-input::placeholder {
  color: #6b7280;
}

.map-search-actions {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  flex: 0 0 auto;
  position: relative;
  z-index: 2;
}

.map-icon-btn {
  border: none;
  background: transparent;
  width: 38px;
  height: 38px;
  border-radius: 999px;
  color: #111827;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.map-icon-btn:hover {
  background: rgba(0, 0, 0, 0.06);
}

.map-icon-btn.active {
  background: rgba(37, 99, 235, 0.14);
  color: #2563eb;
}

.map-filtros-btn {
  color: #374151;
}

.map-filtros-btn:hover {
  background: rgba(0, 0, 0, 0.08);
  color: #111827;
}

.map-type-group {
  margin-left: 4px;
  background: rgba(0, 0, 0, 0.04);
  border-radius: 999px;
  padding: 2px;
}

.map-pill-btn {
  border: none;
  background: transparent;
  border-radius: 999px !important;
  height: 34px;
  width: 44px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #111827;
}

.map-pill-btn.active {
  background: #fff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08);
}

.map-chips-row {
  position: relative;
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
}

.map-chips-row.map-chips-row--top {
  margin-top: 0;
  margin-left: 0;
  /* Ancho: prioridad al carrusel de chips (no al alto) */
  flex: 1 1 520px;
  min-width: 520px;
  width: auto;
  max-width: none;
  padding: 8px 12px;
  background: rgba(255, 255, 255, 0.48);
  -webkit-backdrop-filter: blur(14px) saturate(140%);
  backdrop-filter: blur(14px) saturate(140%);
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.55);
  box-shadow: 0 1px 8px rgba(15, 23, 42, 0.06);
  box-sizing: border-box;
}

.map-chips-scroller {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 8px;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  padding: 2px 2px 6px;
  min-width: 280px;
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: thin;
  scrollbar-color: rgba(0, 0, 0, 0.15) transparent;
  max-width: none;
}

.map-chips-scroller::-webkit-scrollbar {
  height: 4px;
}

.map-chips-scroller::-webkit-scrollbar-track {
  background: transparent;
}

.map-chips-scroller::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.18);
  border-radius: 999px;
}

.map-chip-nav {
  background: rgba(248, 250, 252, 0.92);
  width: 38px;
  height: 38px;
  min-width: 38px;
  border-radius: 999px;
  color: #111827;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06);
  border: 1px solid rgba(0, 0, 0, 0.1);
  flex-shrink: 0;
}

.map-chip-nav.disabled,
.map-chip-nav:disabled {
  opacity: 0.45;
  cursor: not-allowed;
  box-shadow: none;
}

.map-chip-nav:hover {
  border-color: rgba(0, 0, 0, 0.24);
  background: rgba(0, 0, 0, 0.02);
}

.map-chip {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.72);
  border: 1px solid rgba(0, 0, 0, 0.08);
  color: #111827;
  font-size: 13px;
  font-weight: 500;
  line-height: 1.2;
  cursor: pointer;
  user-select: none;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
  flex-shrink: 0;
}

.map-chip i {
  opacity: 0.9;
}

.map-chip:hover {
  border-color: rgba(0, 0, 0, 0.24);
}

.map-chip.active {
  background: rgba(37, 99, 235, 0.12);
  border-color: rgba(37, 99, 235, 0.35);
  color: #1d4ed8;
}

.map-chip.success.active {
  background: rgba(16, 185, 129, 0.14);
  border-color: rgba(16, 185, 129, 0.45);
  color: #047857;
}

.map-chip.warning.active {
  background: rgba(245, 158, 11, 0.16);
  border-color: rgba(245, 158, 11, 0.45);
  color: #92400e;
}

.map-chip.danger.active {
  background: rgba(220, 38, 38, 0.14);
  border-color: rgba(220, 38, 38, 0.45);
  color: #b91c1c;
}

/* Pantallas medianas: misma zona superior, dos filas si no cabe */
@media (max-width: 1100px) {
  .map-top-toolbar {
    flex-wrap: wrap;
    align-items: flex-start;
  }

  .map-searchbar {
    flex: 1 1 240px;
    max-width: none;
  }

  .map-chips-row.map-chips-row--top {
    flex: 1 1 100%;
    max-width: none;
    min-width: 0;
  }
}

/* Responsive optimizado */
@media (max-width: 768px) {
  .trazabilidad-floating-window {
    top: 10px;
    right: 10px;
    left: 10px;
    width: auto;
    max-width: none;
  }

  .map-overlay-ui {
    left: 100px;
    top: 8px;
    max-width: calc(100% - 100px - 56px);
  }

  .map-top-toolbar {
    flex-direction: column;
    align-items: stretch;
    flex-wrap: nowrap;
    width: 100%;
    max-width: calc(100% - 100px - 56px);
  }

  .map-searchbar {
    max-width: none;
    width: 100%;
    min-width: 0;
  }

  .map-chips-row.map-chips-row--top {
    max-width: none;
    width: 100%;
    min-width: 0;
    flex: 1 1 auto;
    padding: 8px 10px;
  }

  .map-chips-scroller {
    min-width: 0;
  }

  .map-search-input {
    flex: 1 1 160px;
    min-width: 140px;
  }

  .map-search-leading {
    width: 38px;
    height: 38px;
  }

  .map-chip-nav {
    width: 32px;
    height: 32px;
  }

  .map-chip {
    padding: 7px 10px;
    font-size: 12px;
  }
}
</style>
